(function () {
  'use strict';

  var STORAGE_KEY = 'ens_quote_attribution';
  var trackedStarts = {};

  function readGclCookie() {
    var match = document.cookie.match(/(?:^|; )_gcl_aw=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getStoredAttribution() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    } catch (error) {
      return {};
    }
  }

  function captureAttribution() {
    var params = new URLSearchParams(window.location.search || '');
    var previous = getStoredAttribution();
    var data = {
      gclid: params.get('gclid') || previous.gclid || '',
      gbraid: params.get('gbraid') || previous.gbraid || '',
      wbraid: params.get('wbraid') || previous.wbraid || '',
      utm_source: params.get('utm_source') || previous.utm_source || '',
      utm_medium: params.get('utm_medium') || previous.utm_medium || '',
      utm_campaign: params.get('utm_campaign') || previous.utm_campaign || '',
      utm_term: params.get('utm_term') || previous.utm_term || '',
      utm_content: params.get('utm_content') || previous.utm_content || '',
      landing_page: previous.landing_page || window.location.href,
      referrer: previous.referrer || document.referrer || '',
      gcl_aw_present: Boolean(readGclCookie())
    };

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {}
    return data;
  }

  function track(eventName, formId, formSource, extra) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: eventName,
      quote_form_id: formId || '',
      quote_form_source: formSource || '',
      quote_attribution: captureAttribution()
    }, extra || {}));
  }

  function trackStart(form) {
    var formId = form.id || form.getAttribute('data-form-id') || 'quote-form';
    var trackingKey = formId + '|' + (form.getAttribute('name') || '') + '|' + window.location.pathname;
    if (trackedStarts[trackingKey]) return;
    trackedStarts[trackingKey] = true;
    var sourceField = form.querySelector('[name="form_source"]');
    track('ens_quote_form_start', formId, sourceField ? sourceField.value : 'unknown');
  }

  document.addEventListener('focusin', function (event) {
    var form = event.target.closest && event.target.closest('form');
    if (form && form.matches('[data-ens-quote-form], .quote-form, form[action*="quote"]')) trackStart(form);
  });

  captureAttribution();
  window.EasyNeonQuoteTracking = {
    attribution: captureAttribution,
    appendToFormData: function (formData) {
      formData.set('attribution', JSON.stringify(captureAttribution()));
      return formData;
    },
    submitSuccess: function (formId, formSource, extra) {
      track('ens_quote_submit_success_detail', formId, formSource, extra);
    },
    submitFailure: function (formId, formSource, extra) {
      track('ens_quote_submit_failure', formId, formSource, extra);
    }
  };
})();
